<template>
  <div v-loading="formLoading" class="formLoading">
    <el-tabs :value="activatName" type="card">
      <el-tab-pane  v-for="(dic, index) in dictDataList" :label="dic.dictLabel" :name="dic.dictCode" :key="index">
        <register-components
        :query-division="index == 0 ? true : false"
        @loading="formLoadingStatus"
        :dict-data="dic"
        @formVerify="formVerify"
        ref="form"
        :submit-falg="false"
        :user-falg="false"
        :disabled-falg="disabledFalg"
        :form="form"
        :field-name-options="fieldMap[dic.dictCode]"
        :site-id="siteId"
        @project="project"
        @startAndEndDate="startAndEndDate"
      ></register-components>
      </el-tab-pane>
    </el-tabs>
    <!-- <div v-for="(dic, index) in dictDataList"> -->
      <!-- <register-components
        :query-division="index == 0 ? true : false"
        @loading="formLoadingStatus"
        :dict-data="dic"
        @formVerify="formVerify"
        ref="form"
        :submit-falg="false"
        :user-falg="false"
        :disabled-falg="disabledFalg"
        :form="form"
        :field-name-options="fieldMap[dic.dictCode]"
        :site-id="siteId"
        @project="project"
        @startAndEndDate="startAndEndDate"
      ></register-components> -->
      <!--      <el-row>-->
      <!--        <el-col  :span="24">-->
      <!--          <div style="height: 2px;margin-left: 100px;margin-right: 100px;margin-bottom: 10px" :style="{'background-color':lineColor}">-->
      <!--          </div>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
    <!-- </div> -->
    <div>
      <div
        slot="footer"
        class="dialog-footer"
        style="padding-bottom: 20px; text-align: center"
      >
        <el-button
          v-show="showAndEdit"
          :disabled="submitFormFalg"
          v-if="!disabledFalg"
          type="primary"
          @click="submitForm"
          >{{operate}}</el-button
        >
        <el-button @click="toSignUpList" v-if="!disabledFalg">返 回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import RegisterComponents from '../form/registerComponents'
import {
  addData,
  updateData,
  conditionByParticipantData
} from '@/api/registerForm'
export default {
  name: 'registerTearmComponents',
  components: { RegisterComponents },
  props: [
    'form',
    'siteId',
    'disabledFalg',
    'dictDataList',
    'fieldMap',
    'lineColor',
    'fieldNameOptions'
  ],
  data () {
    return {
      disFlag: true,
      submitFormFalg: false,
      formCount: 0,
      formLoading: true,
      formLoadingCount: 0,
      // 项目参数
      projectType: 0,
      showAndEdit: true,
      operate: '确 定',
      showBcak: true,
      activatName: '1'
    }
  },
  created () {
    if (this.$route.query.workState == 'show') {
      this.showAndEdit = false
    } else if (this.$route.query.workState == 'edit') {
      this.showAndEdit = true
      this.operate = '修改'
    }
    this.activatName = this.dictDataList[0].dictCode
  },
  watch: {
    projectType (newV, oldV) {
      this.$emit('worktype', newV)
    },
    deep: true // 深度监听父组件传过来对象变化
  },
  methods: {
    toSignUpList () {
      this.$router.push({
        path: '/myHome',
        query: { id: 1 }
      })
    },
    formLoadingStatus (falg) {
      this.formLoadingCount++
      if (this.formLoadingCount == this.dictDataList.length) {
        this.formLoadingCount = 0
        this.formLoading = false
      }
    },
    // 取消按钮
    cancel () {
      this.$emit('back', false)
    },
    project (val) {
      this.projectType = val
    },
    startAndEndDate (val) {
      this.showAndEdit = val
    },
    formVerify (falg) {
      if (falg) {
        this.formCount++
      } else {
        this.formCount = 0
      }
    },
    replaceIdCardNum (str) {
      let arr = Array.from(str)
      arr[2] = '*'
      arr[3] = '*'
      arr[4] = '*'
      arr[5] = '*'
      arr[6] = '*'
      arr[7] = '*'
      arr[10] = '*'
      arr[11] = '*'
      arr[12] = '*'
      arr[13] = '*'
      return arr.join('')
    },
    submitForm () {
      this.formCount = 0
      this.$refs['form'].forEach((item) => {
        item.formVerify()
      })
      if (this.formCount == this.$refs['form'].length) {
        this.formCount = 0
        this.form.siteId = this.siteId
        this.form.userId = this.$store.state.user.userId
        let formData = {}
        this.fieldNameOptions.forEach((field) => {
          formData[field.labelField] = this.form[field.labelField]
        })
        this.dictDataList.forEach((dic) => {
          formData[dic.dictCode + 'child'] = this.form[dic.dictCode + 'child']
        })

        if (formData.idCord) {
          if (formData.idCord !== '') {
            formData.idCord = this.replaceIdCardNum(formData.idCord)
          }
        }
        if (formData.playerIdCord) {
          if (formData.playerIdCord !== '') {
            formData.playerIdCord = this.replaceIdCardNum(formData.playerIdCord)
          }
        }
        if (formData.player2IdCord) {
          if (formData.player2IdCord !== '') {
            formData.player2IdCord = this.replaceIdCardNum(formData.player2IdCord)
          }
        }
        if (formData.player3IdCord) {
          if (formData.player3IdCord !== '') {
            formData.player3IdCord = this.replaceIdCardNum(formData.player3IdCord)
          }
        }
        if (formData.player4IdCord) {
          if (formData.player4IdCord !== '') {
            formData.player4IdCord = this.replaceIdCardNum(formData.player4IdCord)
          }
        }
        if (formData.teacher1IdCard) {
          if (formData.teacher1IdCard !== '') {
            formData.teacher1IdCard = this.replaceIdCardNum(formData.teacher1IdCard)
          }
        }
        if (formData.teacher2IdCard) {
          if (formData.teacher2IdCard !== '') {
            formData.teacher2IdCard = this.replaceIdCardNum(formData.teacher2IdCard)
          }
        }

        if (this.form.idCord) {
          if (this.form.idCord !== '') {
            this.form.idCord = this.replaceIdCardNum(this.form.idCord)
          }
        }
        if (this.form.playerIdCord) {
          if (this.form.playerIdCord !== '') {
            this.form.playerIdCord = this.replaceIdCardNum(this.form.playerIdCord)
          }
        }
        if (this.form.player2IdCord) {
          if (this.form.player2IdCord !== '') {
            this.form.player2IdCord = this.replaceIdCardNum(this.form.player2IdCord)
          }
        }
        if (this.form.player3IdCord) {
          if (this.form.player3IdCord !== '') {
            this.form.player3IdCord = this.replaceIdCardNum(this.form.player3IdCord)
          }
        }
        if (this.form.player4IdCord) {
          if (this.form.player4IdCord !== '') {
            this.form.player4IdCord = this.replaceIdCardNum(this.form.player4IdCord)
          }
        }
        if (this.form.teacher1IdCard) {
          if (this.form.teacher1IdCard !== '') {
            this.form.teacher1IdCard = this.replaceIdCardNum(this.form.teacher1IdCard)
          }
        }
        if (this.form.teacher2IdCard) {
          if (this.form.teacher2IdCard !== '') {
            this.form.teacher2IdCard = this.replaceIdCardNum(this.form.teacher2IdCard)
          }
        }
        this.form.data = JSON.stringify(formData)
        this.submitFormFalg = true
        if (this.form.id != undefined) {
          // 根据站点ID、用户ID、作品类型查询该作品类型是否已报名
          conditionByParticipantData(this.baseURL, {
            siteId: this.siteId,
            userId: this.$store.state.user.userId,
            competitionProject: formData.CompetitionProject
          }).then((res) => {
            // 循环遍历 当前选择类型和已报名类型对比
            if (res.data.length >= 1) {
              res.data.forEach((element) => {
                updateData(this.baseURL, this.form)
                  .then((response) => {
                    if (response.code === 200) {
                      this.disFlag = false
                      this.$message.success('修改成功')
                      this.cancel()
                      this.$router.push({
                        path: '/myHome',
                        query: { articleId: '1' }
                      })
                    }
                  })
                  .catch((e) => {
                    this.submitFormFalg = false
                  })
              })
            } else {
              // 未报名 进行新增
              addData(this.baseURL, this.form)
                .then((response) => {
                  if (response.code === 200) {
                    this.disFlag = false
                    this.$message.success('新增成功')
                    this.cancel()
                    this.$router.push({
                      path: '/myHome',
                      query: { articleId: '1' }
                    })
                  }
                })
                .catch((e) => {
                  this.submitFormFalg = false
                })
            }
          })
        } else {
          addData(this.baseURL, this.form)
            .then((response) => {
              if (response.code === 200) {
                this.disFlag = false
                this.$message.success('新增成功')
                this.cancel()
                this.$router.push({
                  path: '/myHome',
                  query: { articleId: '1' }
                })
              }
            })
            .catch((e) => {
              this.submitFormFalg = false
            })
        }
      }
    }
  }
}
</script>

<style scoped>
.formLoading {
  padding-top: 20px;
  /* padding-right: 150px; */
}
.dialog-footer {
  margin-left: 100px;
}
@media screen and (max-width: 1200px) {
  .formLoading {
    padding-top: 20px;
    padding-right: 0px;
  }
  .dialog-footer {
    margin-left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/my/form/registerTearmComponents.vue